import React, {useState} from "react";
import {withStyles} from "@material-ui/core";
import i18n from "../../../i18n";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import Button from "@material-ui/core/Button";
import FormSelect from "../../Form/FormSelect";
import Grid from "@material-ui/core/Grid/Grid";
import FormField from "../../Form/FormField";
import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";
import ReactDOM from "react-dom";
import swal from "sweetalert";
import SwalList from "../../Helper/SwalList";

const swalList = (list) => {

    const content = list.map((item) => {
        if(item.date) {
            const date = moment(item.date);
            return date.format('DD.MM.YYYY') + ': ' + item.old + ' -> ' + item.new;
        }
        return item;
    });

    let wrapper = document.createElement('div');
    wrapper.style.marginTop = '15px';

    ReactDOM.render(
        <SwalList values={{messages: content}}
                  listItemStyles={{
                      textAlign: 'start',
                      paddingTop: 0,
                      paddingBottom: 0,
                      fontSize: '0.9em',
                  }}
        />,
        wrapper
    );
    return wrapper.firstChild;
};

const progress = () => {
    let wrapper = document.createElement('div');
    ReactDOM.render(
        <CircularProgress size={50} thickness={5} style={{'color': '#db2129'}} />,
        wrapper
    );
    let content = wrapper.firstChild;

    return swal({
        content: content,
        text:i18n.get('personnel.dialog.please_have_patience'),
        buttons:false,
        closeOnClickOutside: false,
        closeOnEsc: false,
    });
}


const sendData = async (values, building, personnel) => {

    let url = `personnel/swap/building`;

    /*** show circular progress icon while rendering pdf */
    progress();

    const listHeader = i18n.get(
        'personnel.dialog.swap_successfully_text',
        {
            personnel: personnel
        },
    );
    let hasChanged = false;
    await axios.post(url, values)
        .then((res) => {
            if (res.status === 200) {
                if(res.data.changes.length) {
                    hasChanged = true;
                    swal({
                        title: i18n.get('personnel.dialog.swap_successfully'),
                        text: listHeader,
                        content: swalList(res.data.changes),
                        icon: 'success',
                        button: {
                            text: "ok",
                            closeModal: false,
                        },
                        closeOnClickOutside: false,
                        closeOnEsc: false,
                        // timer: 4000,
                    }).then((res) => {
                        if(res) {
                            swal.close();
                        }
                    });
                } else {
                    swal({
                        text: i18n.get(
                            'personnel.dialog.no_changes',
                            {
                                building: building,
                                personnel: personnel,
                            }),
                        icon: "info"
                    });
                }
            }
        }).catch(error => {
            console.debug('error', error);
        });
    return hasChanged;
}

const SwapPersonnelDialog = (props) => {
    const {
        classes,
        open,
        handleClose,
        data,
    } = props;

    // lists of all buildings and personnel
    const { buildings, personnel } = data;

    // const dataList = (item) => new Map([
    //     ['building', buildings],
    //     ['personnel', personnel],
    // ]).get(item);

    const defaultValues = {
        building: null,
        personnel: null,
        from: '',
        to: '',
    };

    const [values, setValues] = useState(defaultValues);
    const [buildingName, setBuildingName] = useState('');
    const [personnelName, setPersonnelName] = useState('');

    const setFieldValue = (field, value) => {
        values[field] = value;
        setValues({...values});
    }

    const changeValues = (type, id) => {
        setFieldValue(type, id);
        // const filteredObject = _.find( dataList(type), ['id', id]);
        // console.log('filteredObject',filteredObject);
    }

    const closeDialog = () => {
        setValues(defaultValues);
        handleClose();
    }

    const handleSubmit = () => {
        sendData(values, buildingName, personnelName).then(res => {
            if(res) {
                closeDialog();
            }
        })
    }

    return (
        <Dialog open={open}
                onClose={closeDialog}
                disableBackdropClick={true}
                className={classes.dialog}
                fullWidth={true}
                maxWidth={'sm'}
                aria-labelledby="form-dialog-title">

            <DialogTitle id="form-dialog-title" className={classes.dialogTitle} disableTypography>
                <Typography variant="h6" color={"primary"}>
                    {i18n.get('personnel.dialog.swap_personnel')}
                </Typography>
                <IconButton aria-label="close" className={classes.closeButton} onClick={closeDialog}>
                    <Icon>close</Icon>
                </IconButton>
                {/*<div style={{fontSize:18, color:'#999999'}}>*/}

                {/*</div>*/}
                {/*<div style={{fontSize:11,color:'#999999'}}>*/}
                {/*    {i18n.get('building.site_journal.hints')}*/}
                {/*    <ul>*/}
                {/*        <li>{i18n.get('building.site_journal.hint_begin')}</li>*/}
                {/*        <li>{i18n.get('building.site_journal.hint_end')}</li>*/}
                {/*    </ul>*/}
                {/*</div>*/}
            </DialogTitle>

            <DialogContent  className={classes.dialogContent}>

                <Grid spacing={8} container >

                    <Grid item xs={12}>
                        <FormSelect
                            type="text"
                            name="personnel"
                            label={i18n.get('personnel.dialog.employee')}
                            onChange={option => {
                                changeValues('personnel', option ? option.value : null);
                                setPersonnelName(option?.name);
                            }}
                            options={
                                personnel
                                    ? personnel.map( (person) => ({
                                        name: person.first_name + ' ' + person.last_name,
                                        label: person.last_name + ', ' + person.first_name,
                                        value: person.id,
                                    }))
                                    : ['']
                            }
                            value={values.personnel}
                            isClearable={true}
                            autoComplete={"off"}
                        />
                    </Grid>


                    {values.personnel && (
                        <React.Fragment>
                            <Grid item xs={12}>
                                <FormSelect
                                    type="text"
                                    name="building"
                                    label={i18n.get('personnel.dialog.new_construction_project')}
                                    onChange={option => {
                                        changeValues('building', option ? option.value : null);
                                        setBuildingName(option?.label);
                                    }}
                                    options={
                                        buildings
                                            ? buildings.map(building => ({label: building.name, value: building.id}))
                                            : ['']
                                    }
                                    value={values.building}
                                    isClearable={true}
                                    autoComplete={"off"}
                                />
                            </Grid>
                            {values.building && (
                                <React.Fragment>
                                    <Grid item xs={6}>
                                        <FormField
                                            type="date"
                                            name="from"
                                            label={i18n.get('personnel.dialog.from')}
                                            InputLabelProps={{shrink: true}}
                                            onChange={e => {
                                                setFieldValue('from',e.target.value);
                                            }}
                                            value={values.from}
                                            // inputProps={{
                                            //     min: filter && filter['total_period']['first_date'],
                                            //     max: values.end,
                                            // }}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormField
                                            type="date"
                                            name="to"
                                            label={i18n.get('personnel.dialog.to')}
                                            InputLabelProps={{shrink: true}}
                                            onChange={e => {
                                                setFieldValue('to',e.target.value);
                                            }}
                                            value={values.to}
                                            // inputProps={{
                                            //     min: filter && filter['total_period']['first_date'],
                                            //     max: values.end,
                                            // }}
                                        />
                                    </Grid>
                                </React.Fragment>

                            )}
                        </React.Fragment>
                    )}

                </Grid>
            </DialogContent>
            {values.to && (
                <DialogActions className={classes.dialogActions}>
                    {/*<Button
                    component={'a'}
                    variant={'contained'}
                    color={'primary'}
                    size={'small'}
                    name={'preview'}
                    onClick={handleSubmit}
                >
                    {i18n.get('building.actions.print_preview')}
                </Button>*/}
                    <Button
                        component={'a'}
                        variant={'contained'}
                        color={'primary'}
                        size={'small'}
                        style={{marginLeft:10}}
                        name={'download'}
                        onClick={handleSubmit}
                    >
                        {i18n.get('personnel.dialog.assign')}
                    </Button>
                </DialogActions>
            )}
        </Dialog>
    );

}

const styles = theme => ({
    dialog: {
        minHeight:700,
    },
    dialogTitle: {
        color: theme.colors.primary,
    },
    dialogContent: {
        overflow:'visible',
    },
    dialogActions: {
        paddingRight: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing.unit * 1.2,
        top: theme.spacing.unit * 2,
    },
    checkBoxDivider: {
        marginTop: '-0.7rem',
        marginBottom:0,
        backgroundColor:'rgba(0, 0, 0, 0.4)',
    },
    group: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    groupBadge: {
        backgroundColor: '#EBECF0',
        borderRadius: '2em',
        color: '#172B4D',
        display: 'inline-block',
        fontSize: 12,
        fontWeight: 'normal',
        lineHeight: '1',
        minWidth: 1,
        padding: '0.16666666666667em 0.5em',
        textAlign: 'center',
    }
});

export default withStyles(styles)(SwapPersonnelDialog);
